/**
 * Uploads a catalog CSV/TSV File directly to S3 using a pre-signed URL.
 * The presigned command for this endpoint doesn't include Content-Type in its
 * SigV4 signature, so no Content-Type header is sent here.
 */
export const uploadCatalogFileToS3 = async (uploadUrl: string, file: File): Promise<void> => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
  });

  if (!response.ok) {
    throw new Error(`S3 upload failed with status ${response.status}`);
  }
};
